module.exports = __webpack_public_path__ + "img/gfm.7dfa7ee1.png";